import { createApp } from 'vue'
import App from './App.vue'
import Vue from 'vue'
const xms = require('./utils/xms').default
import router from './router'
import store from './store'
import i18n from './lang'
import '@/styles/public.scss'
import * as filters from './filters' // global filters
// import ElementPlus from 'element-plus'
// Vue.use(ElementPlus)
import Element from 'element-ui'
Vue.use(Element, {
  size: xms.storageGet('size') || 'small', // 设置UI默认尺寸
  i18n: (key, value) => i18n.t(key, value)
})

import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

Vue.component('VueSlider', VueSlider)
	
import directives from './utils/directives'
Vue.use(directives)

Vue.prototype.$eventBus = new Vue();
// 添加实例属性
Object.assign(Vue.prototype, {
  define: require('./utils/define'), // 常量
  xms // 公共方法
})

// 全局注册过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.P = false

const vm = new Vue({ router, store, i18n, render: h => h(App) }).$mount('#app')
export default vm
//createApp(App).mount('#app')
